import { Visit } from '../types/visit';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { ActiveVisitForm } from './ActiveVisitForm';
import { useUpdateVisit } from '../hooks/useUpdateVisit';

interface ActiveVisitDialogProps {
  visit: Visit;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ActiveVisitDialog({ visit, open, onOpenChange }: ActiveVisitDialogProps) {
  const { mutate: updateVisit, isPending } = useUpdateVisit();

  const handleSave = async (data: Partial<Visit>) => {
    updateVisit(
      { ...visit, ...data },
      {
        onSuccess: () => {
          onOpenChange(false);
        },
      }
    );
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl h-[90vh] flex flex-col">
        <DialogHeader>
          <DialogTitle>Active Visit - {visit.title}</DialogTitle>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto">
          <ActiveVisitForm 
            visit={visit} 
            onSave={handleSave}
            isSaving={isPending}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}